import { render, staticRenderFns } from "./SfCollectedProduct.vue?vue&type=template&id=3a002897"
import script from "./SfCollectedProduct.vue?vue&type=script&lang=js"
export * from "./SfCollectedProduct.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfCollectedProduct.vue?vue&type=style&index=0&id=3a002897&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "45f1a3c6"
  
)

export default component.exports